export const GET_LOGGEDIN_USER = 'GET_LOGGEDIN_USER'
export const GET_USER = 'GET_USER';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_LOCATIONS = 'GET_LOCATIONS';
export const GET_COUNTRY = 'GET_COUNTRY';
export const GET_IP_ADDRESS = 'GET_IP_ADDRESS';

export const GET_AUDITS = 'GET_AUDITS';
export const GET_AUDIT = 'GET_AUDIT';
export const GET_USERS = 'GET_USERS';
export const GET_ADMINS = 'GET_ADMINS';

// generics
export const SET_PAGINATION = 'SET_PAGINATION';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_COUNT = 'SET_COUNT';
export const SET_LOADING = 'SET_LOADING';
export const UNSET_LOADING = 'UNSET_LOADING';
export const SET_USERTYPE = 'SET_USERTYPE';
export const SET_RESPONSE = 'SET_RESPONSE';
export const SET_IS_SUPER = 'SET_IS_SUPER';
export const SET_IS_ADMIN = 'SET_IS_ADMIN';
export const SET_SIDEBAR = 'SET_SIDEBAR';
export const SET_USER = 'SET_USER';